export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";